<div class="invite-form">
  <h2 class="form-heading">{{ VendorInvite.VendorInvitationForm }}</h2>
  <form [formGroup]="inviteForm">
    <section class="section">
      <h3 class="section-heading">{{ VendorInvite.OrganizationDetails }}</h3>
      <div class="form-grid">
        <emerald-input
          [label]="VendorInvite.OrganizationName"
          [outlined]="true"
          [isValid]="isFieldValid('organizationName')"
          [errorText]="getFieldError('organizationName')"
          formControlName="organizationName"
        ></emerald-input>
        <emerald-dropdown
          [label]="VendorInvite.OrganizationLocation"
          [outlined]="true"
          [options]="locationOptions"
          [isValid]="isFieldValid('organizationLocation')"
          [errorText]="getFieldError('organizationLocation')"
          formControlName="organizationLocation"
          [preSelectedValue]="'value'"
          [preSelectedLabel]="'label'"
        ></emerald-dropdown>
      </div>
      <emerald-input
        class="address-input"
        [label]="VendorInvite.OrganizationAddress"
        [outlined]="true"
        [isValid]="isFieldValid('organizationAddress')"
        [errorText]="getFieldError('organizationAddress')"
        formControlName="organizationAddress"
      ></emerald-input>
    </section>

    <section class="section">
      <h3 class="section-heading">{{ VendorInvite.Poc }}</h3>
      <div class="form-grid">
        <emerald-input
          [label]="VendorInvite.PocName"
          [outlined]="true"
          [isValid]="isFieldValid('pocName')"
          [errorText]="getFieldError('pocName')"
          formControlName="pocName"
        ></emerald-input>
        <emerald-input
          [label]="VendorInvite.PocContact"
          [outlined]="true"
          [isValid]="isFieldValid('pocContact')"
          [maxLength]="maxLengthTen"
          [errorText]="getFieldError('pocContact')"
          formControlName="pocContact"
          (input)="validateContactNumber($event)"
        ></emerald-input>
      </div>
      <div class="form-grid">
        <emerald-input
          [label]="VendorInvite.PocDesignation"
          [outlined]="true"
          [isValid]="isFieldValid('pocDesignation')"
          [errorText]="getFieldError('pocDesignation')"
          formControlName="pocDesignation"
        ></emerald-input>
        <emerald-input
          [label]="VendorInvite.PocEmail"
          [outlined]="true"
          [isValid]="isFieldValid('pocEmail')"
          [errorText]="getFieldError('pocEmail')"
          formControlName="pocEmail"
        ></emerald-input>
      </div>
    </section>
  </form>

  <section class="section">
    <h3 class="section-heading">{{ VendorInvite.UploadDocuments }}</h3>
    <div class="upload-container">
      <input
        type="file"
        id="file-upload"
        class="file-input"
        multiple
        (change)="onFilesSelected($event)"
        accept="image/jpeg,image/png,application/pdf,video/mp4"
      />
      <label for="file-upload" class="upload-label">
        <div class="upload-content">
          <div class="text-and-formats">
            <div class="drag-drop-text">
              {{ VendorInvite.FileSelect }}
            </div>
            <div class="file-formats">
              {{ VendorInvite.FileFormat }}
            </div>
          </div>
          <emerald-button
            [label]="VendorInvite.BrowseFile"
            [type]="'Light'"
            [disabled]="false"
            (onClick)="onBrowseClick($event)"
          ></emerald-button>
        </div>
      </label>
    </div>
    <div class="selected-files" *ngIf="selectedFiles.length > 0">
      <div
        class="selected-file"
        *ngFor="let file of selectedFiles; let i = index"
      >
        <emerald-icon icon="insert_drive_file"></emerald-icon>
        <div class="file-info">
          <span class="file-name">{{ file.name }}</span>
          <emerald-icon icon="check_circle"></emerald-icon>
          <span class="file-size">{{ file.formattedSize }}</span>
        </div>
        <emerald-icon icon="delete" (click)="removeFile(i)"></emerald-icon>
      </div>
    </div>
    <div class="field-error" *ngIf="fileError">
      <span class="field-error-message">{{ fileError }}</span>
    </div>
  </section>

  <div class="form-actions">
    <emerald-button
      type="Secondary"
      (onClick)="onCancel()"
      [label]="VendorInvite.Cancel"
    ></emerald-button>
    <emerald-button
      type="Primary"
      (onClick)="submit()"
      [label]="VendorInvite.Submit"
    ></emerald-button>
  </div>
</div>
